// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from '@/App'
import router from '@/router/gg/ba'
import fetchStore from '@/store/gg'
import constants from '@/constants'
import i18n from '@/i18n'
import translations from '@/i18n/ba'
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';


const lang = 'ba'
const requireSaleID = false
const store = fetchStore(requireSaleID, constants.API_NTH, process.env.NODE_ENV !== 'production' ? constants.DEV_SERVER : constants.DEFAULT_SERVER,
/^(\+381|00381|0381|0|381)?([1-9][0-9]+)$/, '00381')
Vue.config.productionTip = false
Vue.prototype.$scrollToTop = (n) => window.scrollTo(0,n === undefined ? 0 : n)
Vue.use(Loading)
i18n(Vue, store, translations, lang)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main/gg/ba.js